(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"capa_atlas_1", frames: [[0,1099,310,400],[312,1099,310,400],[624,1099,310,400],[936,1400,310,400],[1248,1400,310,400],[1560,1400,310,400],[0,1501,310,400],[312,1501,310,400],[624,1501,310,400],[0,0,1200,1097],[1202,0,827,896],[1202,898,793,500]]},
		{name:"capa_atlas_2", frames: [[0,0,310,400],[312,0,310,400],[624,0,310,400],[936,0,310,400],[1248,0,310,400],[1560,0,310,400],[0,402,310,400],[312,402,310,400],[624,402,310,400],[936,402,310,400],[1248,402,310,400]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_120 = function() {
	this.initialize(img.CachedBmp_120);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3173,645);


(lib._1523178_7da14_0 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_1 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_10 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_11 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_12 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_13 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_14 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_15 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_16 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_17 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_18 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_19 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_2 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_3 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_4 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_5 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_6 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_7 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_8 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib._1523178_7da14_9 = function() {
	this.initialize(ss["capa_atlas_2"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.Fachadaceu2 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.Fachada_transp = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.Nuvem1 = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.luz = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["rgba(255,255,255,0)","#FFFFFF","rgba(255,255,255,0)"],[0,0.518,1],-92,0,92.1,0).beginStroke().moveTo(-106.1,299.1).lineTo(-106.1,-299.1).lineTo(106.1,-299.1).lineTo(106.1,299.1).closePath();
	this.shape.setTransform(106.05,299.075);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.luz, new cjs.Rectangle(0,0,212.1,598.2), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#BBA467").beginStroke().moveTo(109.4,68.7).curveTo(106.8,67.3,105.5,64.6).lineTo(107.9,63.2).curveTo(109,65.2,111,66.2).curveTo(113.1,67.2,115.4,67.2).curveTo(116.6,67.2,117.6,67.1).curveTo(118.5,66.9,119.7,66.4).curveTo(120.7,65.9,121.3,65.1).curveTo(121.9,64.2,121.9,62.9).curveTo(121.9,62,121.4,61.1).curveTo(120.9,60.4,119.9,59.9).lineTo(117.8,59.2).lineTo(112.6,58.2).lineTo(110.2,57.5).curveTo(109.1,57.1,108.2,56.4).curveTo(107.4,55.6,106.9,54.7).curveTo(106.4,53.7,106.4,52.3).curveTo(106.4,50.5,107.2,49.2).curveTo(108,48,109.4,47.2).curveTo(110.7,46.5,112.2,46.2).curveTo(113.6,45.8,115.3,45.8).curveTo(118.3,45.8,120.5,46.7).curveTo(122.7,47.6,124.1,50).lineTo(121.9,51.3).curveTo(121,49.9,119.2,49.1).curveTo(117.5,48.4,115.4,48.3).curveTo(112.9,48.3,111.1,49.4).curveTo(109.3,50.4,109.3,52.4).curveTo(109.3,53.2,109.7,53.9).curveTo(110.1,54.5,111.2,55).lineTo(113.1,55.7).lineTo(118.4,56.6).curveTo(119.4,56.9,120.8,57.4).curveTo(122.2,57.9,122.9,58.6).curveTo(123.7,59.2,124.2,60.4).curveTo(124.8,61.5,124.8,63).curveTo(124.8,65.1,123.9,66.3).curveTo(123.1,67.7,121.7,68.4).curveTo(120.3,69.3,118.7,69.6).curveTo(117.2,69.9,115.3,69.9).curveTo(112.1,70,109.4,68.7).closePath().moveTo(77.1,68.9).curveTo(74.8,67.9,73.4,66.2).curveTo(72,64.7,71.2,62.4).curveTo(70.5,60.3,70.5,58).curveTo(70.5,52.8,73.7,49.3).curveTo(76.9,45.9,82.3,45.9).curveTo(87.8,45.9,91,49.4).curveTo(94.1,53.1,94,58).curveTo(94,60.3,93.3,62.4).curveTo(92.5,64.7,91.1,66.2).curveTo(89.7,67.9,87.4,68.9).curveTo(85.1,70,82.3,69.9).curveTo(79.5,70,77.1,68.9).closePath().moveTo(75.7,51.2).curveTo(73.3,54,73.3,58).curveTo(73.3,61.8,75.7,64.5).curveTo(78,67.3,82.3,67.2).curveTo(86.5,67.3,88.9,64.5).curveTo(91.1,61.8,91.1,58).curveTo(91.2,55.5,90.3,53.5).curveTo(89.3,51.4,87.3,50).curveTo(85.1,48.5,82.3,48.5).curveTo(78.1,48.5,75.7,51.2).closePath().moveTo(55.4,69.5).lineTo(48.2,61.1).lineTo(42.6,61.1).lineTo(42.6,69.5).lineTo(39.7,69.5).lineTo(39.7,46.3).lineTo(50.2,46.3).curveTo(54,46.3,56,48.4).curveTo(58.1,50.6,58.1,53.7).curveTo(58.2,56.5,56.5,58.6).curveTo(54.8,60.7,51.4,60.9).lineTo(59.1,69.5).closePath().moveTo(42.6,58.5).lineTo(50.1,58.5).curveTo(52.6,58.5,53.9,57.2).curveTo(55.2,55.8,55.2,53.8).curveTo(55.2,51.8,53.9,50.3).curveTo(52.6,48.9,50.2,48.9).lineTo(42.6,48.9).closePath().moveTo(22,69.5).lineTo(22,46.3).lineTo(24.9,46.3).lineTo(24.9,69.5).closePath().moveTo(-8.2,69.5).lineTo(-8.2,46.3).lineTo(8.1,46.3).lineTo(8.1,49).lineTo(-5.3,49).lineTo(-5.3,56.2).lineTo(7.6,56.2).lineTo(7.6,58.9).lineTo(-5.3,58.9).lineTo(-5.3,66.8).lineTo(8.7,66.8).lineTo(8.7,69.5).closePath().moveTo(-25.8,69.5).lineTo(-25.8,59).lineTo(-39.1,59).lineTo(-39.1,69.5).lineTo(-42,69.5).lineTo(-42,46.3).lineTo(-39.1,46.3).lineTo(-39.1,56.3).lineTo(-25.8,56.3).lineTo(-25.8,46.3).lineTo(-22.9,46.3).lineTo(-22.9,69.5).closePath().moveTo(-58.7,69.5).lineTo(-73,51.8).lineTo(-73,69.5).lineTo(-75.8,69.5).lineTo(-75.8,46.3).lineTo(-73.8,46.3).lineTo(-59.6,64.1).lineTo(-59.6,46.3).lineTo(-56.8,46.3).lineTo(-56.8,69.5).closePath().moveTo(-93.5,69.5).lineTo(-93.5,46.3).lineTo(-90.6,46.3).lineTo(-90.6,69.5).closePath().moveTo(-124.8,69.5).lineTo(-124.8,46.3).lineTo(-114.3,46.3).curveTo(-111.9,46.3,-110.4,47.2).curveTo(-108.6,48,-107.7,49.4).curveTo(-106.8,50.8,-106.4,52.5).curveTo(-106,54.2,-106.4,55.8).curveTo(-106.8,57.5,-107.7,58.9).curveTo(-108.6,60.2,-110.4,61.1).curveTo(-112,62,-114.3,62).lineTo(-122,62).lineTo(-122,69.5).closePath().moveTo(-122,59.3).lineTo(-114.3,59.3).curveTo(-112.6,59.3,-111.4,58.5).curveTo(-110.2,57.8,-109.7,56.6).curveTo(-109.2,55.5,-109.2,54.2).curveTo(-109.2,52.8,-109.7,51.7).curveTo(-110.2,50.5,-111.4,49.8).curveTo(-112.6,48.9,-114.3,49).lineTo(-122,49).closePath().moveTo(-303.6,-69.9).lineTo(-289.3,-69.9).curveTo(-262.2,-69.9,-262.2,-53.5).curveTo(-262.2,-46.7,-267.2,-42.5).curveTo(-269.6,-40.6,-272.5,-39.4).curveTo(-267.9,-38.1,-264.7,-35.4).curveTo(-259,-30.3,-259,-22.8).curveTo(-259,-18.3,-260.9,-14.6).lineTo(-275.4,-13.6).curveTo(-272.5,-16.8,-272.5,-23).curveTo(-272.5,-29.7,-276,-32.8).curveTo(-279.7,-35.8,-289,-35.8).lineTo(-290.9,-35.8).lineTo(-290.9,-12.4).lineTo(-303.6,-11.3).closePath().moveTo(-290.9,-63.9).lineTo(-290.9,-41.8).lineTo(-290.6,-41.8).curveTo(-281.7,-41.8,-278.6,-44.4).curveTo(-275.6,-46.9,-275.6,-52.9).curveTo(-275.6,-57.1,-276.8,-59.5).curveTo(-278.1,-61.5,-280.3,-62.6).curveTo(-282.5,-64,-288.9,-64).lineTo(-290.9,-63.9).closePath().moveTo(289.6,-12.6).curveTo(292.7,-15.2,293,-18.7).curveTo(293.4,-22.4,291.2,-25).curveTo(288.8,-28,281.5,-32.1).curveTo(274.5,-36.1,271.1,-38.7).curveTo(267.5,-41.6,265.6,-46).curveTo(263.7,-50.2,264.3,-55).curveTo(265,-62.1,270.5,-66.3).curveTo(275.9,-70.4,283.4,-69.7).curveTo(287.3,-69.3,291,-67.6).curveTo(294.5,-65.8,299,-59.8).lineTo(294,-55.6).curveTo(291.8,-59,291.3,-59.5).curveTo(288.2,-63.3,283.3,-63.8).curveTo(278.9,-64.2,276.8,-62.3).curveTo(274.6,-60.2,274.3,-57.5).curveTo(273.9,-54.3,276.2,-51.7).curveTo(278.5,-48.9,286,-44.5).curveTo(293.7,-39.9,296.6,-37.8).curveTo(300.3,-34.9,302.1,-30.7).curveTo(304,-26.4,303.5,-21).curveTo(302.9,-15.7,300,-11.7).closePath().moveTo(266.3,-14.3).curveTo(263.9,-16.7,262.3,-19.3).lineTo(266.6,-23.9).curveTo(269.8,-19.3,272.2,-16.9).curveTo(274.6,-14.5,277.2,-13.5).closePath().moveTo(-210.7,-69.9).lineTo(-198,-69.9).lineTo(-198,-18).lineTo(-210.7,-17.4).closePath().moveTo(198.3,-18).lineTo(200.5,-18.9).curveTo(204.8,-20.8,206.6,-23.5).curveTo(208.9,-26.6,209.2,-29.1).curveTo(210.1,-34.3,210.1,-39.2).lineTo(210.1,-69.9).lineTo(216,-69.9).lineTo(216,-38.9).curveTo(216,-33.2,215.1,-27).curveTo(214.4,-23.1,210.8,-18.7).lineTo(209.7,-17.5).closePath().moveTo(166.7,-19.2).lineTo(165.6,-20.9).curveTo(162.6,-26.4,163.1,-33.7).lineTo(163.5,-40).lineTo(163.5,-69.9).lineTo(176.1,-69.9).lineTo(176.1,-39.7).lineTo(176.2,-31.1).curveTo(176.4,-27.2,176.7,-25.9).curveTo(177.4,-22.2,180.8,-19.7).curveTo(181.6,-19.1,182.6,-18.6).closePath().moveTo(-150.3,-37.6).curveTo(-150.3,-52.3,-140.5,-61.1).curveTo(-135.4,-65.7,-130.6,-67.7).curveTo(-125.2,-69.9,-118.1,-69.9).curveTo(-111,-69.9,-105.7,-67.8).curveTo(-100.8,-65.8,-95.6,-61.3).curveTo(-85.6,-52.3,-85.6,-37.2).curveTo(-85.6,-28.2,-89.3,-21.2).lineTo(-101.7,-21).curveTo(-99.6,-26.5,-99.6,-37.2).curveTo(-99.6,-44.5,-100.5,-49).curveTo(-101.5,-54.1,-104,-57.2).curveTo(-106.6,-60.7,-109.8,-62.3).curveTo(-113.2,-64,-118.1,-64).curveTo(-122.8,-64,-125.7,-62.4).curveTo(-128.3,-61,-131.1,-57.4).curveTo(-136.4,-50.7,-136.4,-37.2).curveTo(-136.4,-26.7,-133.2,-20.2).lineTo(-145.8,-19.9).curveTo(-150.3,-27.4,-150.3,-37.6).closePath().moveTo(101.6,-21).lineTo(99.1,-27).lineTo(79.1,-27).lineTo(76.9,-21.4).lineTo(70.1,-21.5).lineTo(90.1,-69.9).lineTo(94.4,-69.9).lineTo(115.4,-20.7).closePath().moveTo(81.3,-32.8).lineTo(96.8,-32.8).lineTo(88.9,-51.8).closePath().moveTo(-37.5,-69.9).lineTo(-24.8,-69.9).lineTo(-24.8,-41.7).lineTo(4.4,-41.7).lineTo(4.4,-69.9).lineTo(17.1,-69.9).lineTo(17.1,-21.9).lineTo(4.4,-21.9).lineTo(4.4,-35.8).lineTo(-24.8,-35.8).lineTo(-24.8,-21.9).lineTo(-37.5,-21.9).closePath();
	this.shape.setTransform(260.5812,60.0342,0.8582,0.8582);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo, new cjs.Rectangle(0,0,521.2,120.1), null);


(lib.cloud1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Nuvem1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.cloud1, new cjs.Rectangle(0,0,793,500), null);


(lib.animaTree1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-166.3,98.4).lineTo(-166.3,-98.4).lineTo(166.2,-98.4).lineTo(166.2,98.4).closePath();
	mask.setTransform(124.4,87.575);

	// Camada_2
	this.instance = new lib._1523178_7da14_0();

	this.instance_1 = new lib._1523178_7da14_1();

	this.instance_2 = new lib._1523178_7da14_2();

	this.instance_3 = new lib._1523178_7da14_3();

	this.instance_4 = new lib._1523178_7da14_4();

	this.instance_5 = new lib._1523178_7da14_5();

	this.instance_6 = new lib._1523178_7da14_6();

	this.instance_7 = new lib._1523178_7da14_7();

	this.instance_8 = new lib._1523178_7da14_8();

	this.instance_9 = new lib._1523178_7da14_9();

	this.instance_10 = new lib._1523178_7da14_10();

	this.instance_11 = new lib._1523178_7da14_11();

	this.instance_12 = new lib._1523178_7da14_12();

	this.instance_13 = new lib._1523178_7da14_13();

	this.instance_14 = new lib._1523178_7da14_14();

	this.instance_15 = new lib._1523178_7da14_15();

	this.instance_16 = new lib._1523178_7da14_16();

	this.instance_17 = new lib._1523178_7da14_17();

	this.instance_18 = new lib._1523178_7da14_18();

	this.instance_19 = new lib._1523178_7da14_19();

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2,this.instance_3,this.instance_4,this.instance_5,this.instance_6,this.instance_7,this.instance_8,this.instance_9,this.instance_10,this.instance_11,this.instance_12,this.instance_13,this.instance_14,this.instance_15,this.instance_16,this.instance_17,this.instance_18,this.instance_19];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance_9}]},3).to({state:[{t:this.instance_10}]},3).to({state:[{t:this.instance_11}]},3).to({state:[{t:this.instance_12}]},3).to({state:[{t:this.instance_13}]},3).to({state:[{t:this.instance_14}]},3).to({state:[{t:this.instance_15}]},3).to({state:[{t:this.instance_16}]},3).to({state:[{t:this.instance_17}]},3).to({state:[{t:this.instance_18}]},3).to({state:[{t:this.instance_19}]},3).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,290.7,186);


(lib.nuvem1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.cloud1();
	this.instance.setTransform(385.1,19.1,1.0574,1.3932,0,0,180,396.4,250);
	this.instance.alpha = 0.3594;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(514).to({_off:false},0).to({scaleX:0.759,scaleY:1,x:3184,y:27.3,alpha:0},2384).wait(1));

	// Camada_1
	this.instance_1 = new lib.cloud1();
	this.instance_1.setTransform(396.5,250,1,1,0,0,0,396.5,250);
	this.instance_1.alpha = 0.7109;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({x:3416,alpha:0},1883).to({_off:true},1).wait(1015));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.3,-329.2,3846.8,829.2);


(lib.animaLogo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_254 = function() {
		this.gotoAndPlay(50);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(254).call(this.frame_254).wait(1));

	// Camada_4 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_54 = new cjs.Graphics().moveTo(93.9,58.9).curveTo(91.7,57.8,90.6,55.4).lineTo(92.6,54.2).curveTo(93.5,55.9,95.3,56.8).curveTo(97.1,57.7,99,57.7).curveTo(100.1,57.7,101,57.6).curveTo(101.7,57.5,102.8,57).curveTo(103.6,56.6,104.1,55.8).curveTo(104.6,55.1,104.6,54).curveTo(104.6,53.2,104.2,52.5).curveTo(103.7,51.8,102.9,51.5).lineTo(101.1,50.8).lineTo(96.6,50).lineTo(94.6,49.4).curveTo(93.7,49,92.9,48.4).curveTo(92.2,47.8,91.8,47).curveTo(91.3,46.1,91.3,44.9).curveTo(91.3,43.3,92,42.3).curveTo(92.7,41.2,93.9,40.5).curveTo(95,39.9,96.3,39.6).curveTo(97.5,39.3,99,39.3).curveTo(101.6,39.3,103.4,40.1).curveTo(105.3,40.9,106.5,42.9).lineTo(104.6,44.1).curveTo(103.9,42.8,102.3,42.2).curveTo(100.8,41.6,99,41.5).curveTo(96.9,41.5,95.3,42.4).curveTo(93.8,43.3,93.8,44.9).curveTo(93.8,45.7,94.2,46.3).curveTo(94.5,46.8,95.4,47.2).lineTo(97.1,47.8).lineTo(101.6,48.6).curveTo(102.5,48.8,103.7,49.3).curveTo(104.9,49.7,105.5,50.3).curveTo(106.1,50.8,106.6,51.8).curveTo(107.1,52.7,107.1,54.1).curveTo(107.1,55.8,106.4,56.9).curveTo(105.7,58.1,104.4,58.8).curveTo(103.2,59.4,101.9,59.7).curveTo(100.6,60,99,60).curveTo(96.2,60,93.9,58.9).closePath().moveTo(66.2,59.2).curveTo(64.2,58.3,63,56.8).curveTo(61.8,55.5,61.1,53.6).curveTo(60.5,51.8,60.5,49.7).curveTo(60.5,45.3,63.2,42.4).curveTo(66,39.4,70.6,39.4).curveTo(75.4,39.4,78.1,42.4).curveTo(80.7,45.6,80.7,49.7).curveTo(80.7,51.8,80.1,53.6).curveTo(79.4,55.5,78.2,56.8).curveTo(77,58.3,75,59.2).curveTo(73.1,60,70.6,60).curveTo(68.2,60,66.2,59.2).closePath().moveTo(65,44).curveTo(62.9,46.4,62.9,49.7).curveTo(62.9,53,65,55.4).curveTo(66.9,57.7,70.6,57.7).curveTo(74.3,57.7,76.3,55.4).curveTo(78.2,53,78.2,49.7).curveTo(78.3,47.7,77.5,45.9).curveTo(76.7,44.1,74.9,42.9).curveTo(73,41.7,70.6,41.7).curveTo(67,41.7,65,44).closePath().moveTo(47.6,59.7).lineTo(41.4,52.5).lineTo(36.5,52.5).lineTo(36.5,59.7).lineTo(34.1,59.7).lineTo(34.1,39.7).lineTo(43.1,39.7).curveTo(46.3,39.7,48.1,41.6).curveTo(49.9,43.5,49.9,46.1).curveTo(49.9,48.5,48.5,50.3).curveTo(47,52.1,44.1,52.3).lineTo(50.7,59.7).closePath().moveTo(36.5,50.3).lineTo(43,50.3).curveTo(45.1,50.3,46.3,49.1).curveTo(47.4,47.9,47.4,46.2).curveTo(47.4,44.5,46.3,43.2).curveTo(45.1,41.9,43.1,41.9).lineTo(36.5,41.9).closePath().moveTo(18.9,59.7).lineTo(18.9,39.7).lineTo(21.4,39.7).lineTo(21.4,59.7).closePath().moveTo(-7,59.7).lineTo(-7,39.7).lineTo(7,39.7).lineTo(7,42).lineTo(-4.6,42).lineTo(-4.6,48.2).lineTo(6.5,48.2).lineTo(6.5,50.6).lineTo(-4.6,50.6).lineTo(-4.6,57.3).lineTo(7.5,57.3).lineTo(7.5,59.7).closePath().moveTo(-22.2,59.7).lineTo(-22.2,50.6).lineTo(-33.5,50.6).lineTo(-33.5,59.7).lineTo(-36,59.7).lineTo(-36,39.7).lineTo(-33.5,39.7).lineTo(-33.5,48.4).lineTo(-22.2,48.4).lineTo(-22.2,39.7).lineTo(-19.7,39.7).lineTo(-19.7,59.7).closePath().moveTo(-50.4,59.7).lineTo(-62.6,44.5).lineTo(-62.6,59.7).lineTo(-65.1,59.7).lineTo(-65.1,39.7).lineTo(-63.3,39.7).lineTo(-51.2,55).lineTo(-51.2,39.7).lineTo(-48.7,39.7).lineTo(-48.7,59.7).closePath().moveTo(-80.3,59.7).lineTo(-80.3,39.7).lineTo(-77.8,39.7).lineTo(-77.8,59.7).closePath().moveTo(-107.1,59.7).lineTo(-107.1,39.7).lineTo(-98.1,39.7).curveTo(-96,39.7,-94.7,40.5).curveTo(-93.2,41.2,-92.4,42.4).curveTo(-91.7,43.6,-91.3,45).curveTo(-90.9,46.5,-91.3,47.9).curveTo(-91.6,49.3,-92.4,50.5).curveTo(-93.2,51.7,-94.7,52.4).curveTo(-96.1,53.2,-98.1,53.2).lineTo(-104.7,53.2).lineTo(-104.7,59.7).closePath().moveTo(-104.7,50.9).lineTo(-98.1,50.9).curveTo(-96.6,50.9,-95.6,50.3).curveTo(-94.6,49.6,-94.1,48.6).curveTo(-93.7,47.6,-93.7,46.5).curveTo(-93.7,45.3,-94.1,44.3).curveTo(-94.6,43.3,-95.6,42.7).curveTo(-96.6,42,-98.1,42).lineTo(-104.7,42).closePath().moveTo(-260.6,-60).lineTo(-248.2,-60).curveTo(-225,-60,-225,-45.9).curveTo(-225,-40.1,-229.3,-36.5).curveTo(-231.3,-34.8,-233.8,-33.8).curveTo(-229.9,-32.7,-227.2,-30.3).curveTo(-222.2,-26,-222.2,-19.6).curveTo(-222.2,-15.7,-223.9,-12.5).lineTo(-236.3,-11.7).curveTo(-233.9,-14.4,-233.9,-19.8).curveTo(-233.9,-25.5,-236.8,-28.1).curveTo(-240,-30.8,-248,-30.8).lineTo(-249.7,-30.8).lineTo(-249.7,-10.6).lineTo(-260.6,-9.7).closePath().moveTo(-249.7,-54.8).lineTo(-249.7,-35.9).lineTo(-249.4,-35.9).curveTo(-241.7,-35.9,-239.1,-38.1).curveTo(-236.5,-40.2,-236.5,-45.4).curveTo(-236.5,-49,-237.6,-51.1).curveTo(-238.6,-52.8,-240.5,-53.8).curveTo(-242.4,-54.9,-247.9,-54.9).lineTo(-249.7,-54.8).closePath().moveTo(248.5,-10.8).curveTo(251.2,-13,251.5,-16).curveTo(251.8,-19.2,249.9,-21.5).curveTo(247.9,-24,241.6,-27.5).curveTo(235.6,-30.9,232.7,-33.2).curveTo(229.6,-35.7,228,-39.5).curveTo(226.3,-43.1,226.8,-47.1).curveTo(227.5,-53.3,232.2,-56.9).curveTo(236.8,-60.4,243.2,-59.8).curveTo(246.6,-59.5,249.7,-58).curveTo(252.7,-56.5,256.6,-51.3).lineTo(252.3,-47.7).curveTo(250.5,-50.6,250,-51.1).curveTo(247.3,-54.3,243.2,-54.7).curveTo(239.4,-55.1,237.5,-53.4).curveTo(235.6,-51.7,235.4,-49.3).curveTo(235,-46.5,237,-44.4).curveTo(239,-42,245.4,-38.2).curveTo(252,-34.2,254.6,-32.4).curveTo(257.7,-30,259.3,-26.3).curveTo(260.9,-22.6,260.5,-18).curveTo(260,-13.5,257.5,-10).closePath().moveTo(228.5,-12.3).curveTo(226.5,-14.3,225.1,-16.6).lineTo(228.8,-20.5).curveTo(231.5,-16.5,233.6,-14.5).curveTo(235.6,-12.5,237.9,-11.6).closePath().moveTo(-180.8,-60).lineTo(-169.9,-60).lineTo(-169.9,-15.4).lineTo(-180.8,-14.9).closePath().moveTo(170.2,-15.4).lineTo(172.1,-16.2).curveTo(175.8,-17.8,177.3,-20.2).curveTo(179.3,-22.8,179.6,-25).curveTo(180.3,-29.4,180.3,-33.6).lineTo(180.3,-60).lineTo(185.4,-60).lineTo(185.4,-33.3).curveTo(185.4,-28.4,184.6,-23.2).curveTo(184,-19.8,180.9,-16).lineTo(180,-15).closePath().moveTo(143,-16.5).lineTo(142.1,-17.9).curveTo(139.5,-22.6,140,-28.9).lineTo(140.3,-34.3).lineTo(140.3,-60).lineTo(151.2,-60).lineTo(151.2,-34).lineTo(151.2,-26.7).curveTo(151.4,-23.4,151.6,-22.2).curveTo(152.3,-19,155.1,-16.9).lineTo(156.7,-16).closePath().moveTo(-129,-32.3).curveTo(-129,-44.9,-120.5,-52.4).curveTo(-116.2,-56.4,-112,-58.1).curveTo(-107.4,-60,-101.4,-60).curveTo(-95.3,-60,-90.7,-58.2).curveTo(-86.5,-56.5,-82.1,-52.6).curveTo(-73.4,-44.9,-73.4,-32).curveTo(-73.4,-24.2,-76.6,-18.2).lineTo(-87.2,-18).curveTo(-85.4,-22.7,-85.4,-31.9).curveTo(-85.4,-38.2,-86.2,-42.1).curveTo(-87.1,-46.4,-89.2,-49.1).curveTo(-91.5,-52.1,-94.2,-53.4).curveTo(-97.2,-54.9,-101.4,-54.9).curveTo(-105.4,-54.9,-107.9,-53.5).curveTo(-110.1,-52.3,-112.5,-49.3).curveTo(-117.1,-43.5,-117.1,-32).curveTo(-117.1,-22.9,-114.3,-17.4).lineTo(-125.1,-17.1).curveTo(-129,-23.5,-129,-32.3).closePath().moveTo(87.2,-18).lineTo(85.1,-23.2).lineTo(67.9,-23.2).lineTo(66,-18.4).lineTo(60.1,-18.4).lineTo(77.4,-60).lineTo(81,-60).lineTo(99,-17.8).closePath().moveTo(69.8,-28.2).lineTo(83.1,-28.2).lineTo(76.3,-44.5).closePath().moveTo(-32.2,-60).lineTo(-21.3,-60).lineTo(-21.3,-35.8).lineTo(3.8,-35.8).lineTo(3.8,-60).lineTo(14.7,-60).lineTo(14.7,-18.8).lineTo(3.8,-18.8).lineTo(3.8,-30.7).lineTo(-21.3,-30.7).lineTo(-21.3,-18.8).lineTo(-32.2,-18.7).closePath();

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(54).to({graphics:mask_graphics_54,x:1196.415,y:161.225}).wait(56).to({graphics:null,x:0,y:0}).wait(145));

	// Camada_5
	this.instance = new lib.luz();
	this.instance.setTransform(763.35,157.05,1,1,18.7391,0,0,106,299.1);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(54).to({_off:false},0).to({x:1583.35},40).to({_off:true},16).wait(145));

	// Camada_2
	this.instance_1 = new lib.logo();
	this.instance_1.setTransform(1196.45,161.2,1,1,0,0,0,260.6,60);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(19).to({_off:false},0).to({alpha:1},20).wait(216));

	// Camada_3 (mask)
	var mask_1 = new cjs.Shape();
	mask_1._off = true;
	var mask_1_graphics_0 = new cjs.Graphics().moveTo(-45,209.1).lineTo(-45,-209.1).lineTo(45,-209.1).lineTo(45,209.1).closePath();
	var mask_1_graphics_1 = new cjs.Graphics().moveTo(-90.8,209.1).lineTo(-90.8,-209.1).lineTo(90.8,-209.1).lineTo(90.8,209.1).closePath();
	var mask_1_graphics_2 = new cjs.Graphics().moveTo(-136.6,209.1).lineTo(-136.6,-209.1).lineTo(136.6,-209.1).lineTo(136.6,209.1).closePath();
	var mask_1_graphics_3 = new cjs.Graphics().moveTo(-182.4,209.1).lineTo(-182.4,-209.1).lineTo(182.4,-209.1).lineTo(182.4,209.1).closePath();
	var mask_1_graphics_4 = new cjs.Graphics().moveTo(-228.2,209.1).lineTo(-228.2,-209.1).lineTo(228.2,-209.1).lineTo(228.2,209.1).closePath();
	var mask_1_graphics_5 = new cjs.Graphics().moveTo(-274,209.1).lineTo(-274,-209.1).lineTo(274,-209.1).lineTo(274,209.1).closePath();
	var mask_1_graphics_6 = new cjs.Graphics().moveTo(-319.8,209.1).lineTo(-319.8,-209.1).lineTo(319.8,-209.1).lineTo(319.8,209.1).closePath();
	var mask_1_graphics_7 = new cjs.Graphics().moveTo(-365.6,209.1).lineTo(-365.6,-209.1).lineTo(365.6,-209.1).lineTo(365.6,209.1).closePath();
	var mask_1_graphics_8 = new cjs.Graphics().moveTo(-411.4,209.1).lineTo(-411.4,-209.1).lineTo(411.4,-209.1).lineTo(411.4,209.1).closePath();
	var mask_1_graphics_9 = new cjs.Graphics().moveTo(-457.2,209.1).lineTo(-457.2,-209.1).lineTo(457.2,-209.1).lineTo(457.2,209.1).closePath();
	var mask_1_graphics_10 = new cjs.Graphics().moveTo(-503,209.1).lineTo(-503,-209.1).lineTo(503,-209.1).lineTo(503,209.1).closePath();
	var mask_1_graphics_11 = new cjs.Graphics().moveTo(-548.8,209.1).lineTo(-548.8,-209.1).lineTo(548.8,-209.1).lineTo(548.8,209.1).closePath();
	var mask_1_graphics_12 = new cjs.Graphics().moveTo(-594.6,209.1).lineTo(-594.6,-209.1).lineTo(594.6,-209.1).lineTo(594.6,209.1).closePath();
	var mask_1_graphics_13 = new cjs.Graphics().moveTo(-640.4,209.1).lineTo(-640.4,-209.1).lineTo(640.4,-209.1).lineTo(640.4,209.1).closePath();
	var mask_1_graphics_14 = new cjs.Graphics().moveTo(-686.2,209.1).lineTo(-686.2,-209.1).lineTo(686.2,-209.1).lineTo(686.2,209.1).closePath();
	var mask_1_graphics_15 = new cjs.Graphics().moveTo(-732,209.1).lineTo(-732,-209.1).lineTo(732,-209.1).lineTo(732,209.1).closePath();
	var mask_1_graphics_16 = new cjs.Graphics().moveTo(-777.8,209.1).lineTo(-777.8,-209.1).lineTo(777.8,-209.1).lineTo(777.8,209.1).closePath();
	var mask_1_graphics_17 = new cjs.Graphics().moveTo(-823.6,209.1).lineTo(-823.6,-209.1).lineTo(823.6,-209.1).lineTo(823.6,209.1).closePath();
	var mask_1_graphics_18 = new cjs.Graphics().moveTo(-869.4,209.1).lineTo(-869.4,-209.1).lineTo(869.4,-209.1).lineTo(869.4,209.1).closePath();
	var mask_1_graphics_19 = new cjs.Graphics().moveTo(-915.2,209.1).lineTo(-915.2,-209.1).lineTo(915.2,-209.1).lineTo(915.2,209.1).closePath();

	this.timeline.addTween(cjs.Tween.get(mask_1).to({graphics:mask_1_graphics_0,x:-137,y:157.05}).wait(1).to({graphics:mask_1_graphics_1,x:-91.2,y:157.05}).wait(1).to({graphics:mask_1_graphics_2,x:-45.4,y:157.05}).wait(1).to({graphics:mask_1_graphics_3,x:0.4,y:157.05}).wait(1).to({graphics:mask_1_graphics_4,x:46.2,y:157.05}).wait(1).to({graphics:mask_1_graphics_5,x:92,y:157.05}).wait(1).to({graphics:mask_1_graphics_6,x:137.8,y:157.05}).wait(1).to({graphics:mask_1_graphics_7,x:183.6,y:157.05}).wait(1).to({graphics:mask_1_graphics_8,x:229.4,y:157.05}).wait(1).to({graphics:mask_1_graphics_9,x:275.2,y:157.05}).wait(1).to({graphics:mask_1_graphics_10,x:320.975,y:157.05}).wait(1).to({graphics:mask_1_graphics_11,x:366.775,y:157.05}).wait(1).to({graphics:mask_1_graphics_12,x:412.575,y:157.05}).wait(1).to({graphics:mask_1_graphics_13,x:458.375,y:157.05}).wait(1).to({graphics:mask_1_graphics_14,x:504.175,y:157.05}).wait(1).to({graphics:mask_1_graphics_15,x:549.975,y:157.05}).wait(1).to({graphics:mask_1_graphics_16,x:595.775,y:157.05}).wait(1).to({graphics:mask_1_graphics_17,x:641.575,y:157.05}).wait(1).to({graphics:mask_1_graphics_18,x:687.375,y:157.05}).wait(1).to({graphics:mask_1_graphics_19,x:733.175,y:157.05}).wait(236));

	// Camada_1
	this.instance_2 = new lib.CachedBmp_120();
	this.instance_2.setTransform(0,0,0.5,0.5);

	var maskedShapeInstanceList = [this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(255));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1586.5,322.5);


(lib.anima = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.animaTree1();
	this.instance.setTransform(861.5,1039.35,0.8294,0.6794,0,0,180,122.2,87.2);

	this.instance_1 = new lib.animaTree1();
	this.instance_1.setTransform(733.95,1043.55,0.9153,0.7497,0,0,0,122.2,87.3);

	this.instance_2 = new lib.animaTree1();
	this.instance_2.setTransform(92.9,1080.75,0.8321,0.6816,30.2066,0,0,122.2,87.4);

	this.instance_3 = new lib.Fachada_transp();
	this.instance_3.setTransform(8,107.8,1.0956,1.0956);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Camada_3
	this.instance_4 = new lib.nuvem1();
	this.instance_4.setTransform(-298.15,363.9,0.8793,0.7279,0,0,0,396.4,250);
	this.instance_4.alpha = 0.8711;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// Camada_1
	this.instance_5 = new lib.Fachadaceu2();

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	// Camada_4
	this.instance_6 = new lib.animaLogo();
	this.instance_6.setTransform(866.4,575.85,1,1,0,0,0,793.1,161.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.anima, new cjs.Rectangle(-646.7,0,2306.5,1343.5), null);


// stage content:
(lib.capa = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		const loadController = () => {
		    if (typeof (window.parent.AllTap) !== 'undefined') {
		        /**
		         *
		         * Class reference.
		         */
		        const
		            AllTapParent = window.parent.AllTap,
		            name_current = 'capa';
		
		        /**
		         *
		         *  @param object
		         *  Set "this", object of canvas CreateJs.
		         */
		        AllTapParent.setState({...AllTapParent.state, [`_this_${name_current}`]: this});
		
		        this.gotoAndStop('frame01');
		
		        createjs.Ticker.removeEventListener('tick', loadController);
		    }
		};
		
		createjs.Ticker.addEventListener('tick', loadController);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1));

	// Background
	this.instance = new lib.anima();
	this.instance.setTransform(821.8,460.5,1,1,0,0,0,829.8,548.5);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1651.8,1255.5);
// library properties:
lib.properties = {
	id: '0FBEFCCB6FA99240974BF4F7DBA4F13D',
	width: 1920,
	height: 1000,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/CachedBmp_120.png?1705062000276", id:"CachedBmp_120"},
		{src:"./images/capa_atlas_1.png?1705062000257", id:"capa_atlas_1"},
		{src:"./images/capa_atlas_2.png?1705062000257", id:"capa_atlas_2"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['0FBEFCCB6FA99240974BF4F7DBA4F13D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
